import React from 'react';
import FormGroup from '../../shared/components/forms/FormGroup';
import { TalkToAnalystFields } from './TalkToAnalystFields';
import FormTextarea from '../../shared/components/forms/FormTextarea';
import { QUESTION_TYPE_OPTIONS } from './constant/options';
import FormSelect from '../../shared/components/forms/components/select/FormSelect';
import { QuestionTypeOption } from '../../shared/enums/QuestionTypeOption';

interface Props {
  isSubmitted: boolean;
}

const getDefaultQuestionType = (): QuestionTypeOption | undefined => {
  const params = new URLSearchParams(window.location.search);
  const type = params.get('questionType');
  if (!type) return undefined;

  // Check if the value matches any enum value
  const values = Object.values(QuestionTypeOption);
  return values.includes(type as QuestionTypeOption) ? (type as QuestionTypeOption) : undefined;
};

const TalkToAnalystForm: React.FC<Props> = props => {
  const defaultQuestionType = getDefaultQuestionType();

  return (
    <>
      <FormGroup>
        <b>I have a question about</b>

        <FormSelect
          isMultiSelect={false}
          name={TalkToAnalystFields.QuestionAbout}
          placeholder="Choose the question type"
          options={QUESTION_TYPE_OPTIONS}
          isDisabled={props.isSubmitted}
          defaultContactQuestionType={defaultQuestionType}
        />
      </FormGroup>

      <FormGroup>
        <b>Enter your question and we&apos;ll forward it to our research and support teams</b>

        <FormTextarea
          name={TalkToAnalystFields.QuestionToAnalyst}
          placeholder="Enter your question"
          isDisabled={props.isSubmitted}
        />
      </FormGroup>
    </>
  );
};

export default TalkToAnalystForm;
